import {
  PAGE_STATUSES as SharedPAGE_STATUSES,
  ORG_VANITY_URL_REQUEST_STATUSES as SharedORG_VANITY_URL_REQUEST_STATUSES,
} from "shared/dist/types/Page";

import type {
  Page as SharedPage,
  PageStatus,
  OrgVanityUrlRequest as SharedOrgVanityUrlRequest,
  OrgVanityUrlRequestStatus,
} from "shared/dist/types/Page";

export type { PageStatus, OrgVanityUrlRequestStatus };

export const PAGE_STATUSES = SharedPAGE_STATUSES;
export const ORG_VANITY_URL_REQUEST_STATUSES = SharedORG_VANITY_URL_REQUEST_STATUSES;

export interface OrgVanityUrlRequest extends SharedOrgVanityUrlRequest {}

export default interface Page extends SharedPage {}
